import React from 'react';
import { usePriceConfig } from './PriceContext';
export function Footer() {
  const price = usePriceConfig();
  return <footer className="bg-leather py-12 px-4 border-t-8 border-[#8B5A2B]" data-id="element-91">
      <div className="max-w-6xl mx-auto" data-id="element-92">
        

        {/* Footer Links */}
        <div className="border-t-2 border-[#6F6F6F] pt-8 text-center" data-id="element-93">
          <p className="text-sm text-[#6F6F6F] mb-4 font-bold uppercase tracking-wider" data-id="element-94">
            © {new Date().getFullYear()} Fábrica Industrial — Todos Los
            Derechos Reservados
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-95">
            <a href="#" className="text-[#6F6F6F] hover:text-[#8B5A2B] transition-colors font-bold uppercase tracking-wide" data-id="element-96">
              Términos y Condiciones
            </a>
            <a href="#" className="text-[#6F6F6F] hover:text-[#8B5A2B] transition-colors font-bold uppercase tracking-wide" data-id="element-97">
              Política de Privacidad
            </a>
            <a href="#" className="text-[#6F6F6F] hover:text-[#8B5A2B] transition-colors font-bold uppercase tracking-wide" data-id="element-98">
              Contacto
            </a>
          </div>
        </div>
      </div>
    </footer>;
}